import { FormGroup, FormBuilder, Validators } from '@angular/forms';

export class ApplicationACHInfo {

    form: FormGroup;

    constructor(private formBuilder: FormBuilder) {
        this.form = this.formBuilder.group({
            accountName: ['', Validators.required],
            accountNumber: ['', Validators.required],
            accountNumberConfirm: ['', Validators.required],
            accountRoutingNumber: ['', Validators.required],
            bankName: ['', Validators.required],
            city: ['', Validators.required],
            state: ['', Validators.required]
        }, {
            validator: MustMatch('accountNumber', 'accountNumberConfirm')
        });
    }

    decode(data: any) {
        this.form.controls.accountName.setValue(data.accountName);
        this.form.controls.accountNumber.setValue(data.accountNumber);
        this.form.controls.accountNumberConfirm.setValue(data.accountNumberConfirm);
        this.form.controls.accountRoutingNumber.setValue(data.accountRoutingNumber);
        this.form.controls.bankName.setValue(data.bankName);
        this.form.controls.city.setValue(data.city);
        this.form.controls.state.setValue(data.state);
    }

    encode(): any {
        return {
            accountName: this.form.controls.accountName.value,
            accountNumber: this.form.controls.accountNumber.value,
            accountNumberConfirm: this.form.controls.accountNumberConfirm.value,
            accountRoutingNumber: this.form.controls.accountRoutingNumber.value,
            bankName: this.form.controls.bankName.value,
            city: this.form.controls.city.value,
            state: this.form.controls.state.value,
            accountType: "CHECKING"
        };
    }

    setDefaultData() {
        this.decode(
            {
                accountName: 'Audio visual equipment',
                accountNumber: '1222613232',
                accountNumberConfirm: '1222613232',
                accountRoutingNumber: '121000358',
                bankName: 'US Bank association',
                city: 'Bremen',
                state: 'AL'
            }
        );
    }
}

function MustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];
        const matchingControl = formGroup.controls[matchingControlName];

        if (matchingControl.errors && !matchingControl.errors.mustMatch) {
            // return if another validator has already found an error on the matchingControl
            return;
        }

        // set error on matchingControl if validation fails
        if (control.value !== matchingControl.value) {
            matchingControl.setErrors({ mustMatch: true });
        } else {
            matchingControl.setErrors(null);
        }
    };
}